import { AccountMultiSelector } from "../AccountMultiSelector";

import { IFieldProps } from "./fieldProps";

export function ExcludeAccountLines({
  policyFormData,
  invalids,
  handleChange,
}: IFieldProps) {
  return (
    <AccountMultiSelector
      policy={ policyFormData }
      handleChange={ handleChange }
      invalids={ invalids }
    />
  );
}
